import { ZOHO_CRM_INTEGRATION_USER_PROMPT } from './zohoCrmIntegrationDemoContent.js'

/** @param {string} trimmed */
export function isZohoCrmIntegrationDemoPrompt(trimmed) {
  return trimmed.trim().toLowerCase() === ZOHO_CRM_INTEGRATION_USER_PROMPT.trim().toLowerCase()
}
